<template>
  <div>
    <div>
      <div class="content">
        <div v-show="!loaded">
          <div class="lds-dual-ring"></div>
        </div>
        <div class="inner" v-show="loaded">
          <h1 class="title">
            <strong>{{
              pagetypename.charAt(0).toUpperCase() + pagetypename.slice(1) + (pagetypename == "main" ? " pages" : "")
            }}</strong>
          </h1>

          <div class="actions">
            <a @click.prevent="addPage" class="btn edit-save" href v-if="!shadows && !schema.disallow_new_pages">
              <i class="fa fa-check-square-o"></i> Add
            </a>
            <a @click.prevent="exportPages" class="btn edit-save" href v-if="schema.exportable">
              <i class="fa fa-cloud-download"></i> Export
            </a>

            <div class="filters">
              <select
                :key="filter.prop_name"
                @change="filterChange(filter)"
                v-for="filter in filters.filter((f) => f.type == 'cbo')"
                v-model="filter._value"
                v-show="filter._items && filter._items.length"
              >
                <option value="all">All {{ filter.label }}</option>
                <option :key="item.ItemID" :value="item.ItemID" v-for="item in filter._items">
                  {{ item[filter.list_text] }}
                </option>
              </select>
            </div>
          </div>

          <div class="alpha" v-if="schema.alphasplit">
            <a
              :class="{ active: letterToView == letter, disabled: !letterAvailable(letter) }"
              :key="'a' + letter"
              @click.prevent="chooseLetter(letter)"
              href
              v-for="letter in ['All'].concat(alphabet.split(''))"
              >{{ letter }}</a
            >

            <ul
              :key="'ul' + letter"
              class="list"
              v-for="letter in alphabet.split('')"
              v-show="letterToView == letter || letterToView == 'All'"
            >
              <li :key="page.ItemID" v-for="page in alphasplitpages[letter]">
                <router-link :to="{ name: 'page-edit', params: { id: page.ItemID, type: $route.params.type } }">
                  <i class="fa fa-file-o"></i>
                  <span class="item-name">{{ page.name_ }}</span>
                  <span class="item-labels" v-if="page.labels">
                    <span :key="i" class="item-label" v-for="(label, i) in page.labels">
                      {{ label }}
                      <i class="fa fa-angle-right" v-if="page.labels.length > i + 1"></i>
                    </span>
                  </span>
                  <span class="tooltip" data-balloon="This item is hidden" data-balloon-pos="right" v-show="page.hide">
                    <i class="fa fa-eye-slash hidden"></i>
                  </span>
                </router-link>
                <span class="actions">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="page._loading"></i>

                  <a @click.prevent="duplicate(page)" href="#" v-if="schema.duplicable">
                    <i class="fa fa-copy"></i>
                  </a>
                  <a @click.prevent="updating ? false : confirmDeletePage(page)" class="delete" href="#">
                    <i class="fa fa-trash"></i>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <ul class="list scroller" v-else v-sortable="{ handle: '.handle', onUpdate: reorderPages }">
            <li :key="page.ItemID" v-for="page in pages">
              <router-link :to="{ name: 'page-edit', params: { id: page.ItemID, type: $route.params.type } }">
                <i class="fa fa-file-o"></i>
                {{ page.name_ }}
                <span :key="i" class="label" v-for="(label, i) in page.labels">{{ label }}</span>
                <span class="tooltip" data-balloon="This item is hidden" data-balloon-pos="right" v-show="page.hide">
                  <i class="fa fa-eye-slash hidden"></i>
                </span>
              </router-link>
              <span class="actions">
                <i class="fa fa-circle-o-notch fa-spin" v-if="page._loading"></i>

                <a @click.prevent="duplicate(page)" href="#" v-if="schema.duplicable">
                  <i class="fa fa-copy"></i>
                </a>
                <a :class="{ handle: !updating }" class="move" href="#" v-if="!schema.order_by">
                  <i class="fa fa-sort"></i>
                </a>
                <a @click.prevent="updating ? false : confirmDeletePage(page)" class="delete" href="#">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <modal-yes-no
      :message="'Are you sure you want to delete this?'"
      :show="showDeletePageModal"
      @close="showDeletePageModal = false"
      @yes="deletePage"
    ></modal-yes-no>
  </div>
</template>

<script>
import datetimeutil from "date-and-time"
import api from "@/services/api"
import XLSX from "xlsx"

import ModalYesNo from "@/components/ModalYesNo.vue"

export default {
  name: "Pages",
  components: { ModalYesNo },
  data: function () {
    return {
      loaded: false,
      updating: false,
      pages: [],
      schema: {},
      page_schema: {},
      showDeletePageModal: false,
      pageInQuestion: {},
      pagetype: "",
      pagetypename: "",
      alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ#",
      letterToView: "All",
      filters: [],
      shadows: false
    }
  },
  created() {
    this.pagetypename = this.$route.params.type.replace(/-/g, " ")
    this.pagetype = this.$route.params.type.replace(/-/g, "")
    api.getSchema("page." + this.pagetype).then((response) => {
      var sch = JSON.parse(JSON.stringify(response))

      var p = []
      var shadowed_by = null
      if (sch.items && sch.items.shadowed_by) shadowed_by = sch.items.shadowed_by
      var duplicable = null
      if (sch.items) duplicable = sch.items.duplicable
      if (sch.items && sch.items.shadows) {
        this.shadows = true
        p.push(api.getSchema(sch.items.shadows))
      }

      Promise.all(p).then((val) => {
        if (val.length) {
          sch = Object.assign(sch, JSON.parse(JSON.stringify(val[0])))
          sch.items.shadowed_by = shadowed_by
          sch.items.duplicable = duplicable
        }

        if (sch.items) this.schema = sch.items
        if (sch.item) this.page_schema = sch.item

        var filterpromises = []
        if (this.schema.filter) {
          this.filters = JSON.parse(JSON.stringify(this.schema.filter))
          this.filters.forEach((filter) => {
            if (this.$store.state.display.filters[filter.prop_name]) {
              this.$set(filter, "_value", this.$store.state.display.filters[filter.prop_name])
            } else {
              this.$set(filter, "_value", "all")
            }
          })

          this.filters.forEach((filter) => {
            var filterpromise = []
            if (filter.items.attribute == "ItemType")
              filter.items.values.forEach((value) =>
                filterpromise.push(
                  api.getPages(value.split(".")[1], null, this.internal).then((res) => {
                    return res
                  })
                )
              )

            if (filter.items.attribute == "ItemID")
              filter.items.values.forEach((value) =>
                filterpromise.push(
                  api.getPage(value).then((res) => {
                    if (filter.items.prop_name) return res[filter.items.prop_name]
                    else return res.items
                  })
                )
              )

            filterpromises.push(
              Promise.all(filterpromise).then((val) => {
                if (filter.sort)
                  val[0].sort((a, b) => {
                    var textA = a[filter.list_text].toUpperCase()
                    var textB = b[filter.list_text].toUpperCase()
                    return textA < textB ? -1 : textA > textB ? 1 : 0
                  })
                this.$set(filter, "_allitems", val[0])
                this.$set(filter, "_items", this.filterItems(filter))
              })
            )
          })
        }

        filterpromises.push(this.getPages())

        Promise.all(filterpromises).then(() => {
          if (this.filters)
            this.pages.forEach((page) => {
              this.$set(page, "labels", [])

              this.filters.forEach((f) => {
                var item = f._allitems.filter((i) => i.ItemID == page[f.prop_name])[0]
                if (item && item[f.list_text]) page.labels.push(item[f.list_text])
              })
            })
        })
      })
    })
  },
  computed: {
    internal() {
      return this.schema.type && this.schema.type == "internal"
    },
    exportProps() {
      if (!this.page_schema) return []

      var props = []
      this.page_schema.forEach((section) => {
        if (section.properties) props = props.concat(section.properties.filter((p) => p.export))
      })
      return props
    },
    defaultProps() {
      if (!this.page_schema) return []

      var props = []
      this.page_schema.forEach((section) => {
        if (section.properties) props = props.concat(section.properties.filter((p) => p.default))
      })
      return props
    },
    alphasplitpages() {
      if (!this.pages.length) return []

      var unorganisedpages = JSON.parse(JSON.stringify(this.pages))

      this.filters.forEach((filter) => {
        if (filter._value && filter._value != "all")
          unorganisedpages = unorganisedpages.filter((p) => p[filter.prop_name] == filter._value)
      })

      unorganisedpages.sort((a, b) =>
        a.alphasplitvalue_.toLowerCase() > b.alphasplitvalue_.toLowerCase()
          ? 1
          : b.alphasplitvalue_.toLowerCase() > a.alphasplitvalue_.toLowerCase()
          ? -1
          : 0
      )
      let dict = unorganisedpages.reduce((pages, page) => {
        let currentLetter = page.alphasplitvalue_.trim()[0].toLocaleUpperCase()

        if (!currentLetter.match(/[A-Z]/i)) currentLetter = "#"

        if (pages[currentLetter]) pages[currentLetter].push(page)
        else pages[currentLetter] = [page]

        return pages
      }, {})

      return dict
    }
  },
  methods: {
    filterChange(filter) {
      if (filter.background_prop) {
        this.$set(
          this.filters.filter((f) => f.prop_name == filter.background_prop.prop_name)[0],
          "_value",
          filter.background_prop.value
        )
        this.$store.commit("display/SET_FILTER", {
          name: filter.background_prop.prop_name,
          value: filter.background_prop.value
        })
      }

      this.filters
        .filter((f) => f.filter && f.filter.filter_attribute == filter.prop_name)
        .forEach((f) => this.$set(f, "_items", this.filterItems(f)))

      this.$store.commit("display/SET_FILTER", { name: filter.prop_name, value: filter._value })
    },
    filterItems(filter) {
      if (!filter._allitems) return []
      if (!filter.filter) return filter._allitems

      var parentfilter = this.filters.filter((f) => f.prop_name == filter.filter.filter_attribute)[0]
      if (!parentfilter._value) return []
      return filter._allitems.filter((item) => item[filter.filter.item_attribute] == parentfilter._value)
    },
    letterAvailable(letter) {
      if (letter == "All") return true
      else if (this.alphasplitpages[letter]) return true
      else return false
    },
    chooseLetter(letter) {
      if (this.letterAvailable(letter)) this.letterToView = letter
      else return false
    },
    getPages() {
      return new Promise((resolve, reject) => {
        var fields = []
        if (this.filters)
          this.filters.forEach((f) => {
            if (fields.indexOf(f.prop_name) == -1) fields.push(f.prop_name)
          })
        if (this.schema.item_name_props)
          this.schema.item_name_props.forEach((f) => {
            if (fields.indexOf(f.prop_name) == -1) fields.push(f.prop_name)
          })
        if (this.schema.alphasplit && this.schema.alphasplit.prop_name)
          if (fields.indexOf(this.schema.alphasplit.prop_name) == -1) fields.push(this.schema.alphasplit.prop_name)
        var fieldsstring = fields.join(",")

        var promises = []
        if (this.schema.order_by && (this.schema.order_by.type == "date" || this.schema.order_by.type == "date-ms"))
          promises.push(api.getPagesDesc(this.pagetype, fieldsstring, this.internal))
        else if (this.schema.order && this.schema.order == "desc")
          promises.push(api.getPagesDesc(this.pagetype, fieldsstring, this.internal))
        else promises.push(api.getPages(this.pagetype, fieldsstring, this.internal))

        Promise.all(promises).then((values) => {
          this.pages = values[0]

          this.pages.forEach((page) => {
            var name = ""
            if (this.schema.item_name_props) {
              this.schema.item_name_props.forEach((prop) => {
                if (page[prop.prop_name]) {
                  if (name) name += prop.prefix || " "
                  name += page[prop.prop_name]
                }
              })
            }
            this.$set(page, "name_", name || page.name)

            this.$set(page, "alphasplitvalue_", page.name)
            if (this.schema.alphasplit && this.schema.alphasplit.prop_name)
              this.$set(page, "alphasplitvalue_", page[this.schema.alphasplit.prop_name])
          })

          resolve()

          this.$nextTick().then(() => {
            this.loaded = true
            this.updating = false
          })
        })
      })
    },
    addPage() {
      var orderindex = 1

      if (this.schema.order_by && this.schema.order_by.type == "date")
        orderindex = datetimeutil.format(new Date(), "YYYY-MM-DD")
      else if (this.schema.order_by && this.schema.order_by.type == "date-ms")
        orderindex = Math.floor(new Date().getTime() / 1000).toString()
      else if (this.pages.length) orderindex = this.pages.length + 1

      var initial = {}
      this.defaultProps.forEach((p) => {
        if (p.type == "date-ms") {
          // if (p.default == "today") initial[p.prop_name] = Math.floor(new Date().getTime() / 1000)
          if (p.default == "today") initial[p.prop_name] = Math.floor(new Date().getTime() / 1000).toString()
        } else initial[p.prop_name] = p.default
      })

      api.addPage(this.pagetype, orderindex, initial, this.internal, this.schema.shadowed_by).then((response) =>
        this.$router.push({
          name: "page-edit",
          params: { id: response.data }
        })
      )
    },
    confirmDeletePage(page) {
      this.pageInQuestion = page
      this.showDeletePageModal = true
    },
    duplicate(page) {
      api.getPage(page.ItemID, this.internal, this.schema.shadowed_by).then((fullpage) => {
        var orderindex = 1

        if (this.schema.order_by && this.schema.order_by.type == "date")
          orderindex = datetimeutil.format(new Date(), "YYYY-MM-DD")
        else if (this.schema.order_by && this.schema.order_by.type == "date-ms")
          orderindex = Math.floor(new Date().getTime() / 1000).toString()
        else if (this.pages.length) orderindex = this.pages.length + 1

        if (fullpage.url) fullpage.url = fullpage.url + "-copy"
        fullpage.OrderIndex = orderindex
        api.duplicatePage(fullpage, this.internal).then((response) => {
          this.$store.dispatch({
            type: "setSuccess",
            message: "Copy successful"
          })
          this.$router.push({
            name: "page-edit",
            params: { id: response.data }
          })
        })
      })
    },
    deletePage() {
      if (!this.updating) {
        this.updating = true
        var index = this.pages
          .map((page) => {
            return page.ItemID
          })
          .indexOf(this.pageInQuestion.ItemID)
        this.pages.splice(index, 1)

        this.$set(this.pageInQuestion, "_loading", true)
        api
          .deletePage(this.pageInQuestion, this.internal, this.schema.shadowed_by)
          .then(() => this.getPages())
          .catch(() => (this.pageInQuestion._loading = false))

        if (!this.schema.order_by && !this.schema.alphasplit) this.updateOrderIndexes()
      }
    },
    reorderPages: function (event) {
      this.updating = true
      this.pages.splice(event.newIndex, 0, this.pages.splice(event.oldIndex, 1)[0])
      this.updateOrderIndexes().then(() => this.getPages())
    },
    updateOrderIndexes: function () {
      return new Promise((resolve, reject) => {
        var promises = []
        this.pages.forEach((page, i) => {
          page.OrderIndex = i + 1
          promises.push(api.updatePage(page, this.internal))
        })
        Promise.all(promises).then(() => resolve())
      })
    },
    exportPages: function () {
      api.export(this.exportProps, "page.main", this.internal).then((res) => {
        var data = []
        var header = []

        // Use labels for header row
        this.exportProps.forEach((p) => header.push(p.label))
        data.push(header)

        // Add rows for each page
        res.forEach((page) => {
          var row = []
          this.exportProps.forEach((p) => row.push(page[p.prop_name]))
          data.push(row)
        })

        const ws = XLSX.utils.aoa_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "Sheet 1")

        XLSX.writeFile(wb, "export.xlsx")
      })
    }
  }
}
</script>
